module.exports = __webpack_public_path__ + "static/media/frisovandebeeten.93c767a6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/frisovandebeeten.webp
// module id = 450
// module chunks = 0